module.exports = __webpack_public_path__ + "img/small.bbe5e492.jpg";